import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  login: {
    method: 'POST',
    url: `${configs.baseUrl}/api/connector/login`,
  },
  saveFile: {
    method: 'POST',
    url: `${configs.baseUrl}/api/connector/save-file`,
  },
  checkExistFile: {
    method: 'POST',
    url: `${configs.baseUrl}/api/connector/check-exist-file`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const login = async (params) => {
  const res = await resource.login(params)
  return res.body
}

const saveFile = async (params) => {
  const res = await resource.saveFile(params)
  return res.body
}

const checkExistFile = async (params) => {
  const res = await resource.checkExistFile(params)
  return res.body
}

export default {
  initResource,
  login,
  saveFile,
  checkExistFile,
}
